module.exports = __webpack_public_path__ + "static/media/mpl-qr-footer.c390d0e2.jpg";